import { render } from "./index.vue?vue&type=template&id=deea4d90&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=deea4d90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-deea4d90"

export default script